import PropTypes from 'prop-types'
import React from 'react'
import Edit from '@material-ui/icons/Edit'

const EditIcon = ({ className }) => <Edit className={className} />

export default EditIcon

EditIcon.propTypes = {
  className: PropTypes.string
}
